import { isDevEnvironment } from './env';

/* In here we store the Google Optimize global variables which are the parameters
   for the A/B testing
*/

// the window variable is to be defined.

export const TESTS_DICTIONARY = {
  optimizelyI4Iframe: 'optimizelyI4Iframe', // Added by story 62253(PR#16070), to be cleaned up by story ?????
  optimizelyOfferCallout: 'optimizelyOfferCallout', // Added by story 85776(PR#23548), to be cleaned up by story xxxxx
  optimizelyUFF: 'optimizelyUFF', // Added by story 89247(PR#25012), to be cleaned up by story 90202
  optimizelyFFMEExpediaCarousel: 'optimizelyFFMEExpediaCarousel' // Added by story 91079(PR#?????), to be cleaned up by story 91383
};

/**
 * This is for tests that are located on multiple pages or components.
 * This array is to be empty by default.
 */
const MULTIPLE_TESTS_ACTIVE_LISTS = [];

/**
 *
 * @param {*} testName This is the name of the global variable that is set in Optimizely
 * @param {*} developMode This is a boolean that is set to true if you want to see the test in develop mode
 * @returns
 */
export const getTestValueAB = (testName, developMode = false) => {
  if (developMode) {
    return true;
  }
  if (isDevEnvironment && MULTIPLE_TESTS_ACTIVE_LISTS.includes(testName)) {
    return true;
  }

  return window[testName] || false;
};
